module.exports = __webpack_public_path__ + "img/maintenance.50b34ac5.png";